import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { onMessage } from './actions'

function mapStateToProps(state) {
    return {
        locale: state.getIn(['translate', 'locale']),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ onMessage }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
